const closeSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<path fill-rule="evenodd" d="M17.9149337,16.5010013 L23.9241463,10.4919893 C24.0252846,10.3908545 24.0252846,10.2266355 23.9241463,10.1255007 L22.8737107,9.07610147 C22.7735739,8.97496662 22.6083481,8.97496662 22.5082112,9.07610147 L16.4989986,15.0841121 L10.4917888,9.07510013 C10.3916519,8.97496662 10.2264261,8.97496662 10.1262893,9.07510013 L9.07985914,10.1214953 C8.97471544,10.2266355 8.97471544,10.3868491 9.07985914,10.4919893 L15.0850663,16.4989987 L9.07585367,22.5080107 C8.97471544,22.6091455 8.97471544,22.7733645 9.07585367,22.873498 L10.1262893,23.9238985 C10.2264261,24.0250334 10.3906506,24.0250334 10.4917888,23.9238985 L16.5,17.9148865 L22.5082112,23.9248999 C22.6083481,24.0250334 22.7735739,24.0250334 22.8737107,23.9248999 L23.9201409,22.873498 C24.0252846,22.7733645 24.0252846,22.6081442 23.9201409,22.5080107 L17.9149337,16.5010013 Z"/>
</svg>`

const spinnerPath = "https://assets.icanet.se/EPI-assets/loading_64x64.gif"
import dataLayer from '@/analytics/dataLayer.js'
export function loginModalIframe2 (containerElement, title, loginUrl, opts) {
  const {
    onClose = () => {},
    onMessage = () => {}
  } = opts

  const modalContent = `
  <div class="fullscreen-iframe-modal">
    <div class="fullscreen-iframe-modal__frame-container">
      <header class="fullscreen-iframe-modal__header">
        <h1 class="fullscreen-iframe-modal__header-title">${title}</h1>
        <a class="fullscreen-iframe-modal__header-cancel" href="#close-modal">${closeSVG}</a>
      </header>
      <div class="fullscreen-iframe-modal__spinner-container"><img src="${spinnerPath}" alt=""></div>
      <iframe class="fullscreen-iframe-modal__frame" allowfullscreen="true" src="${loginUrl}"></iframe>
    </div>
  </div>
  `

  containerElement.innerHTML = modalContent
  let modal = containerElement.querySelector('div')
  let closeLink = containerElement.querySelector('header a')

  let initialOverflow = document.body.style.overflow
  let initialPaddingRight = document.body.style.paddingRight

  function onCloseClick (e) {
    e.preventDefault()
    destroy()
    return false
  }

  let destroy = () => {
      // remove event listeners
      window.removeEventListener('message', onMessage)
      modal.removeEventListener('click', onCloseClick)
      closeLink.removeEventListener('click', onCloseClick)

      // remove element from dom
      containerElement.removeChild(modal)

      // restore scrollbars
      document.body.style.overflow = initialOverflow
      document.body.style.paddingRight = initialPaddingRight

      // remove references to dom elements
      modal = null
      closeLink = null

      // set destroy to do nothing after this
      destroy = f => f

      // notify that modal was closed
      onClose()
  }

  // add events
  window.addEventListener('message', onMessage)
  modal.addEventListener('click', onCloseClick)
  // close modal on esc press
  window.addEventListener('keydown', (e) => {
    if (e.keyCode === 27) {
      destroy()
    }
  })

  closeLink.addEventListener('click', onCloseClick)

  // add to dom
  containerElement.appendChild(modal)
  //console.log(dataLayer)
  // track event
  dataLayer.add({
      'event': 'loginModal'
  })

  const scrollBarGap = window.innerWidth - document.documentElement.clientWidth
  document.body.style.overflow = 'hidden'
  if (scrollBarGap > 0) {
    document.body.style.paddingRight = `${scrollBarGap}px`
  }

  // expose close method
  return {
    close: () => { destroy() }
  }
}
